import { render, staticRenderFns } from "./Menu2.vue?vue&type=template&id=3f3ea598"
import script from "./Menu2.vue?vue&type=script&lang=js"
export * from "./Menu2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports